import { Button } from '@hue/design-system';
import { useNavigate } from '@tanstack/react-router';

/// Endereço que não existe, dito dentro da casca de quem está logado.
///
/// Antes de haver rota, qualquer caminho desconhecido caía no console — o que fazia um link
/// digitado errado parecer ter funcionado. Isto aqui é bloco de conteúdo, e não página: o menu
/// continua ao lado, porque quem se perdeu precisa de para onde ir, não de uma saída do sistema.
/// Quem não está logado nem chega a ver esta tela — vai para a entrada, que é a única coisa que
/// existe para essa pessoa.
export function RouteNotFound() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center py-8 text-center">
      {/* O número é decoração: quem ouve a tela recebe o mesmo recado pelo título, e "quatro zero
          quatro" lido em voz alta não diz nada a ninguém. */}
      <p
        aria-hidden="true"
        className="bg-gradient-to-br from-brand-300 via-brand-500 to-brand-600 bg-clip-text text-[clamp(5.5rem,26vw,11rem)] font-black leading-[.85] tracking-[-.06em] text-transparent"
      >
        404
      </p>
      <h1 className="mt-6 text-2xl font-bold tracking-[-.035em] sm:text-3xl">
        Endereço não encontrado
      </h1>
      <p className="mt-3 max-w-md text-sm leading-6 text-content-muted">
        O caminho digitado não corresponde a nenhuma tela. Se você chegou por um link antigo, ele
        pode ter mudado de lugar.
      </p>
      <Button className="mt-8" type="button" onClick={() => void navigate({ to: '/home' })}>
        Ir para o início
      </Button>
    </div>
  );
}
